<!-- eslint-disable prettier/prettier -->
<template>
  <div class="login-page">
    <h1 class="system-title">餐厅系统</h1>
    <div class="login-card">
      <van-form @submit="onSubmit">
        <van-field
          v-model.trim="form.username"
          name="username"
          label="账号"
          placeholder="请输入账号"
          :rules="[{ required: true, message: '请输入账号' }]"
        />
        <van-field
          v-model="form.password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />

        <div class="submit-wrap">
          <van-button block round type="primary" native-type="submit" :loading="loading"
            >登录</van-button
          >
        </div>
        <p class="sub-title">请使用公司员工账号登录</p>
      </van-form>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { showFailToast } from 'vant';
  import { useAuthStore } from '@/store/auth';

  const authStore = useAuthStore();
  const router = useRouter();
  const route = useRoute();
  const loading = ref(false);

  const form = reactive({
    username: '',
    password: '',
  });

  const onSubmit = async (): Promise<void> => {
    loading.value = true;

    try {
      await authStore.login({ username: form.username, password: form.password });
      const redirect = Array.isArray(route.query.redirect)
        ? route.query.redirect[0]
        : route.query.redirect;
      const targetPath = typeof redirect === 'string' && redirect.startsWith('/') ? redirect : '/';
      await router.replace(targetPath);
    } catch (error) {
      const message = error instanceof Error ? error.message : '登录失败';
      showFailToast(message);
    } finally {
      loading.value = false;
    }
  };
</script>

<style scoped>
  .login-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: #f5f5f5;
  }

  .system-title {
    margin: 0 0 16px;
    font-size: 32px;
    font-weight: 700;
    color: #1e293b;
  }

  .login-card {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 30px rgba(24, 39, 75, 0.08);
  }

  .title {
    margin: 0;
    font-size: 24px;
    text-align: left;
  }

  .sub-title {
    margin: 8px 0 20px;
    color: #6b7280;
    font-size: 14px;
    text-align: left;
  }

  .submit-wrap {
    margin-top: 20px;
  }
</style>
